export default __webpack_public_path__ + "static/media/z2.65c64c0f.webp";